/* eslint-disable max-len */
interface WtwLogoProps {
  className?: string;
}

export function WtwLogo({ className }: WtwLogoProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 251.78 100.31"
      width="72"
      height="29"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M237.62,28.33,215.71,85H197.27l-9.22-31.63L178.73,85H160.28l-16.2-42.24H134V61.66c0,8.92,3.61,10.4,8.54,10.4a18.5,18.5,0,0,0,3.88-.5l5,13.16a50.56,50.56,0,0,1-12,1.43c-16.9,0-24.11-6.91-24.11-23.11V42.71h-7.69L91.3,85H72.85L63.63,53.32,54.31,85H35.87L14.16,28.33H35.08L46,62.54,56.39,28.33H70.87L81.38,62.54,92.19,28.33h23.14V18.15l18.66-4V28.33h25.5L170.4,62.54l10.41-34.21h14.47L205.8,62.54l10.8-34.21Z"
        fill="#7f35b2"
      />
    </svg>
  );
}
